// src/components/Hero.tsx
import { useAnalytics } from '../hooks/useAnalytics';

const Hero = () => {
  const { trackEvent } = useAnalytics();

  const handleWaitlistClick = () => {
    trackEvent('cta_click', {
      location: 'hero',
      button_text: 'Join Waitlist'
    });

    // Scroll to contact form
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="container mx-auto px-6 pt-8 pb-16 text-center"
      aria-labelledby="hero-heading"
    >
      <h1 
        id="hero-heading"
        className="mb-6 text-4xl font-bold leading-tight md:text-5xl text-gray-900"
      >
        Centralize Email Signature Management
        <span className="block text-blue-600">for Google Workspace</span>
      </h1>
      <p className="mx-auto mb-8 max-w-2xl text-xl text-gray-600">
        Keep Your Brand Consistent Across Your Organization
      </p>
      <div className="mx-auto mb-12 max-w-3xl rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 p-8 text-left relative overflow-hidden shadow-lg">
        <div className="relative z-10">
          <p className="text-lg text-gray-700">
            SignoBox integrates with Googlw Workspace and your HR system to automatically create, update, and deploy 
            professional email signatures for your entire team, ensuring consistent branding and 
            up-to-date information across your organization.
          </p>
          <div className="mt-6 flex justify-center">
            <button 
              onClick={handleWaitlistClick}
              className="rounded-lg bg-blue-600 px-8 py-3 font-semibold text-white transition-colors hover:bg-blue-700"
            >
              Join Waitlist
            </button>
          </div>
        </div>
        <div className="absolute -bottom-20 -right-20 h-64 w-64 opacity-10">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="#3B82F6" d="M45.7,-52.2C59.9,-40.6,72.5,-26.4,76.2,-10C79.9,6.5,74.8,25.2,63.1,38.3C51.4,51.4,33.3,58.8,14.3,64.8C-4.7,70.7,-24.6,75.1,-39.6,67.9C-54.6,60.7,-64.5,41.8,-68.6,22.4C-72.6,3,-70.8,-16.9,-62,-32.5C-53.1,-48.1,-37.2,-59.5,-21.1,-70C-5,-80.5,11.2,-90.2,26.1,-83.2C41,-76.3,54.4,-52.9,57.3,-45.7C60.1,-38.5,52.3,-32.4,45.7,-26.4Z" transform="translate(100 100)" />
          </svg>
        </div>
      </div>
      <div className="mx-auto max-w-2xl">
        <h2 className="mb-4 text-2xl font-semibold text-gray-900">
          Perfect For:
        </h2>
        <ul className="flex flex-wrap justify-center gap-4 text-lg">
          <li className="rounded-full bg-blue-100 text-blue-800 px-4 py-2">Google Workspace</li>
          <li className="rounded-full bg-blue-100 text-blue-800 px-4 py-2">HR Teams</li>
          <li className="rounded-full bg-blue-100 text-blue-800 px-4 py-2">Marketing Teams</li>
          <li className="rounded-full bg-blue-100 text-blue-800 px-4 py-2">IT Admins</li>
        </ul>
      </div>
    </section>
  );
};

export default Hero;
